import React from 'react'
import music from '../music.jpeg'
import quiz from '../quiz.jpeg'
import fungame from '../fungame.jpeg'
import podcast from '../podcast.jpeg'
import '../Cards.css'
import { Link } from 'react-router-dom'



export default function Cards() {
  return (
    <div style={{marginLeft : '90px' , display : 'flex'}} >
        
        <Link to="/music" >
        <img height="250px" width="300px" className="image" src={music} alt="" />
        </Link>

        <Link to="/games"  >
        <img height="250px" width="300px" className="image" src={fungame} alt="" />
        </Link>

      
        <a href="https://quiz-app-six-chi.vercel.app/" target="_self">
        <img height="250px" width="300px" className="image" src={quiz} alt=""   />
          </a>
    
      
       

        <Link to="/podcast" >
        <img height="250px" width="300px" className="image" src={podcast} alt="" />
        </Link>
    
    </div>
  )
}
